import React, { Component } from 'react';
import { Grid} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import Field from "../../components/forms/field"
import * as api from "../../api";
import FormattedDate from "../../components/formatters/formattedDate";
import Currency from "../../components/formatters/currency";

export default class SupplierInvoiceSummary extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            supplierData: {},
            addressData: []
        }
    }

    componentDidMount = () => {
        this.fetchData();
    }

    parseAddressData() {
        try
        {
        const addressData = this.state.supplierData.supplyAddress.split(/,\s?/);
        this.setState({addressData});
        }catch
        {
        }
    }

    fetchData = () => {
        api.getSpecificSupplierInvoice(this.props.customerId, this.props.supplierInvoiceKey)
            .then(data => this.setState({supplierData: data}, this.parseAddressData));
    }

    render() {
        return (
            <Grid padded stackable columns='equal'>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Invoice No."} value={this.state.supplierData.invoiceNumber} />
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Invoice Date"} value={<FormattedDate value={this.state.supplierData.invoiceDate}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Address"} value={this.state.addressData[0]}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Supplier"} value={this.state.supplierData.supplier}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"CCL"}  value={<Currency value={this.state.supplierData.cclValue}/>}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Invoice Type"} value={this.state.supplierData.invoiceType}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Invoice Status"} value={this.state.supplierData.invoiceStatus}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Address"} value={this.state.addressData[1]}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Supplier Ref"} value={this.state.supplierData.supplierReference}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Gross"} value={<Currency value={this.state.supplierData.gross}/>}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Billing Freq."} value={this.state.supplierData.billingFreq}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Bill Type"} value={this.state.supplierData.billType}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Address"} value={this.state.addressData[2]}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Utility"} value={this.state.supplierData.utility}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"VAT"} value={<Currency value={this.state.supplierData.vat}/>}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"From Date"} value={<FormattedDate value={this.state.supplierData.dateFrom}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"To Date"} value={<FormattedDate value={this.state.supplierData.dateTo}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Postcode"} value={this.state.addressData[this.state.addressData.length-1]}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Payment Status"}  value={this.state.supplierData.paymentStatus}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Balance Brought Forward"} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Journal ID"} value={this.state.supplierData.journalId}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Nett"} value={<Currency value={this.state.supplierData.nett}/>}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Type"} value={this.state.supplierData.dataType}/>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}